import { DefaultApi as ConvAiV2Api } from '@rbx/clients/convAiPlatformOrchestrationService';
import { Configuration } from '@rbx/clients';
import { getBEDEV2ServiceBasePath } from '@modules/utilities/constants/baseUrl';
import {
  PromptMessage,
  MessageRequestType,
  MessageHistoryItem,
  getCreateConversationMessages,
} from '@rbx/conv-ai-provider';

const basePath = getBEDEV2ServiceBasePath('assistant');

const configuration = new Configuration({
  basePath,
  credentials: 'include',
});

const conversationApi = new ConvAiV2Api(configuration);

const inferMessageIsRegenerationRequest = (message: PromptMessage) =>
  message.context?.requestType === MessageRequestType.RegenerationRequest;

export const createConversation = async ({
  conversationId,
  messageHistory,
  messageToSend,
  version = 1,
  isRegenerate = inferMessageIsRegenerationRequest(messageToSend),
}: {
  conversationId?: string;
  messageHistory: MessageHistoryItem[];
  messageToSend: PromptMessage;
  version?: number;
  isRegenerate?: boolean;
}) => {
  if (!messageHistory || !messageToSend) throw Error(`Missing message history or message to send`);
  const conversation = {
    conversationId,
    messages: getCreateConversationMessages(messageHistory.concat([messageToSend])),
    clientContexts: [
      {
        captureTime: 0,
        clientContextData: '{"slash_command": "DocumentAssist"}',
      },
      ...(!isRegenerate
        ? []
        : [
            {
              capture_time: 0,
              regenerate: true,
              clientContextData: '{}',
            },
          ]),
    ],
  };
  /* 
    clientContexts is used to add additional context to the conversation
    in studio, this is used to add dm heirarchy
    in the web, this is used to add the slash command to shortcut the orchestration layer
  */

  try {
    const data = await conversationApi.createConversationConversationsPost({
      requestBody: {
        conversation,
        version,
      },
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export * from '@rbx/clients/convAiPlatformOrchestrationService';
export default { createConversation, conversationApi };
